import * as React from 'react'
import styled from 'styled-components'
import Button from '../../../../common/src/components/Button'
import { H4, Spacer, InputMed } from '../../../../common/src/components/core'
import keyboard, { KeyAction } from '../../../../common/src/keyboard'
import validate, { regex } from '../../../../common/src/validate'

export default class NewThreadSection extends React.PureComponent<
  {
    addressPhone: string
    addressEmail: string
    createThread: (addressUs: string, addressThem: string) => Promise<any>
  },
  {
    hasError: boolean
  }
> {
  private input?: HTMLInputElement
  state = {
    hasError: false,
  }

  componentDidMount() {
    keyboard.addListener(this.onKeyboardBound)
  }

  componentWillUnmount() {
    keyboard.removeListener(this.onKeyboardBound)
  }

  render() {
    return (
      <div>
        <H4>New thread</H4>
        <Spacer height={16} />
        <NewThreadRow>
          <NewThreadAddressInput
            id="new-thread-address"
            placeholder="6501234567 or Jim Bob <jb@c.com> or jim@c.com"
            ref={this.setInputRefBound}
            hasError={this.state.hasError}
            onKeyDown={this.onKeyDownBound}
          />
          <NewThreadButton size="medium" onClick={this.onClickBound}>
            Create
          </NewThreadButton>
        </NewThreadRow>
        <Spacer height={32} />
      </div>
    )
  }

  private onKeyboardBound = (action: KeyAction) => {
    if (action === KeyAction.esc && this.input != null) {
      this.input.blur()
    }
  }

  private setInputRefBound = (ref: HTMLInputElement) => {
    this.input = ref
  }

  private onClickBound = () => {
    const { addressPhone, addressEmail } = this.props

    // Find addressUs (the phone or email for this leasing task)
    // and addressThem (the phone or email for the concact)
    if (this.input == null) {
      return
    }

    // remove invisible characters like \u202c
    const addressThem = this.input.value.replace(regex.controlFormatChars, '')
    const inputResult = validate.phone().validate(addressThem)
    const addressUs = inputResult.error == null ? addressPhone : addressEmail

    this.props
      .createThread(addressUs, addressThem)
      .then(() => {
        if (this.input == null) {
          return
        }
        this.input.value = ''
      })
      .catch(() => {
        this.setState({ hasError: true })
        if (this.input == null) {
          return
        }
        this.input.value = ''
      })
  }

  private onKeyDownBound = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.keyCode === 13) {
      // enter
      this.onClickBound()
    }
  }
}

const NewThreadRow = styled.div`
  display: flex;
`

const NewThreadAddressInput = styled(InputMed)`
  flex-grow: 1;
  margin-right: 16px;
`

const NewThreadButton = styled(Button)`
  position: relative;
  top: 1px;
`
